export default __webpack_public_path__ + "static/media/profile.2fd89963.svg";